export default __webpack_public_path__ + "static/media/imgSfondoOre2.2225ee8c.png";